import React from 'react';

import BlankSideMenu from '../containers/navigation/BlankSideMenu';
import ProjectSelect from '../containers/navigation/ProjectSelect';

const BlankMain = () => (
  <div style={{ display: 'flex', alignItems: 'stretch', height: '100%' }}>
    <div style={{ flexShrink: 0 }}>
      <BlankSideMenu tenantPath="/" />
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflowX: 'hidden' }}>
      <div className="navigation-bar">
        <ProjectSelect />
      </div>
    </div>
  </div>
);

export default BlankMain;
